
import { Injectable } from '@angular/core';
import { HttpService } from '../providers/http.service';
import { AppConfig } from '../app/app.config';

@Injectable()
export class SysconfigService {
    constructor(
        private httpService: HttpService) { }


    // 获取所有线路
    getPlatformLineList() {
        var url = AppConfig.GetProdUrl() + "/System/GetPlatformLineList";
        return this.httpService.post(url, null);
    }
    //获取系统配置
    //TQQ 2017-01-10
    getSysconfig() {
        var url = AppConfig.GetProdUrl() + "/System/SysConfig";
        return this.httpService.get(url);
    }

    //获取phone版本信息
    //chen 2017-10-23
    GetPhoneSettings(param) {
        var url = AppConfig.GetProdUrl() + "/Log/GetPhoneSettings";
        return this.httpService.post(url, param);
    }
    /**
    * 获取手机端轮播图
    *
    * @returns
    * @memberof SysconfigService
    */
    getMobileCarousel() {
        var url = AppConfig.GetProdUrl() + "/System/GetMobileHomePic";
        return this.httpService.get(url);
    }
    //获取客服二维码图片
    getkefuqrcode() {
        var url = AppConfig.GetProdUrl() + "/System/GetKefu";
        return this.httpService.get(url);
    }
    /**
   * 获取客服地址，不需要登陆就可以获得
   * David 2018-06-22
   */
    getServiceHall() {
        var url = AppConfig.GetProdUrl() + "/System/ServiceHall";
        return this.httpService.get(url);
    }
    /**
     * 获取协议与条款
     * an 2019-08-30
     */
    getAgreement() {
        var url = AppConfig.GetProdUrl() + "/System/GetAgreement";
        return this.httpService.get(url);
    }
    // 第三方挂机
    getHangonTool() {
        var url = AppConfig.GetProdUrl() + "/System/GoHangonTool";
        return this.httpService.post(url, null);
    }
    /**
     * 获取维护页面信息
     */
    getMaintainSettings() {
        var url = AppConfig.GetProdUrl() + "/log/getMaintainSettings";
        return this.httpService.post(url, null);
    }
    /**
     * 判断所有第三方游戏是否开启
     */
    getThirdIsOpen() {
        var url = AppConfig.GetProdUrl() + "/System/GetThirdIsOpen";
        return this.httpService.get(url);
    }
    // 立即注册
    register() {
        var url = AppConfig.GetProdUrl() + "/System/GetOpenRegister";
        return this.httpService.get(url);
    }

    /**
    * 注册验证方式
    */
    getValidCodeType() {
        let url = AppConfig.GetProdUrl() + "/system/GetValidCodeType";
        return this.httpService.get(url);
    }

    /** 获取域名地址 */
    getPlatformUrls(param) {
        var url = AppConfig.GetProdUrl() + "/anonymous/GetPlatformUrls";
        return this.httpService.get(url, param);
    }
}




// WEBPACK FOOTER //
// ./src/services/sysconfig.service.ts